export default __webpack_public_path__ + "static/frame-005-19dfe30a376ba42a3b4e95033c0eb507.png";